var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3733 1.28613H8.9269C6.67831 1.28613 4.85547 3.10897 4.85547 5.35756V44.6433C4.85547 46.8919 6.67831 48.7147 8.9269 48.7147H24.3733V1.28613ZM25.6233 48.7147H41.0698C43.3183 48.7147 45.1412 46.8919 45.1412 44.6433V5.35756C45.1412 3.10897 43.3183 1.28613 41.0698 1.28613H25.6233V48.7147ZM33.9269 22.4524C34.2721 22.4524 34.5519 22.7322 34.5519 23.0774V26.9235C34.5519 27.2687 34.2721 27.5485 33.9269 27.5485C33.5817 27.5485 33.3019 27.2687 33.3019 26.9235V23.0774C33.3019 22.7322 33.5817 22.4524 33.9269 22.4524ZM16.6948 23.0774C16.6948 22.7322 16.4149 22.4524 16.0698 22.4524C15.7246 22.4524 15.4448 22.7322 15.4448 23.0774V26.9235C15.4448 27.2687 15.7246 27.5485 16.0698 27.5485C16.4149 27.5485 16.6948 27.2687 16.6948 26.9235V23.0774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothing);
export default __webpack_public_path__ + "static/media/Clothing.41f88fde35e476a259eb342e06ffd764.svg";
export { ForwardRef as ReactComponent };